var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEhIconEdit = function SvgEhIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.44 3.03a1.4 1.4 0 0 0-1.015-.419c-.353 0-.706.132-.993.42l-7.058 7.058c-.176.176-.308.419-.375.684l-.617 2.713c-.044.22.132.42.353.42H2.8s1.875-.398 2.713-.597c.242-.066.485-.198.661-.374l7.08-7.081a1.425 1.425 0 0 0 0-2.008zm-7.014 9.155a.36.36 0 0 1-.155.088c-.397.088-1.059.242-1.61.353l.375-1.61c0-.067.044-.133.088-.177L9.462 5.5l1.323 1.323z"
  })));
};
export default SvgEhIconEdit;